import React, { useContext, useMemo, useState } from 'react'
import { Link, Love, useToast } from 'chemistry'
import DiscountPercentage from '../DiscountPercentage'
import gallerySelector from '../../selectors/gallery'
import { getLocale, getPrefix } from 'common/utils'
import { isOnlineOnly } from 'common/deliveryMode'
import { getProductName } from 'client/common/selectors/product'
import DeliveryModeLabel from 'client/fragments/productDetailsFragmentInfo/components/DeliveryModeLabel'
import EmblaCarousel from './EmblaCarousel'
import { TranslateContext } from 'client/common/translator'

export const WishListIcon = () => <Love color={'grey.900'} />
export const InWishListIcon = () => <Love filled color={'red.500'} />

export const getWishListHref = (inWishList, shortProductCode) =>
  `/wishlist/${inWishList ? 'remove' : 'add'}?code=${shortProductCode}`

export const getWishListIconTitle = inWishList => (inWishList ? 'remove' : 'add')
export const getToastTitle = inWishList => (inWishList ? 'removed' : 'added')
export const getWishListIcon = inWishList => (inWishList ? InWishListIcon : WishListIcon)

export const toggleWishList = async ({ href, toast, title }) => {
  await fetch(`${href}&js=true`)
  return toast({
    position: 'bottom-left',
    title,
    status: 'success'
  })
}

export const DetailImage = ({
  productDetails,
  lang,
  format,
  children,
  allowWishlist,
  productId,
  isGuest,
  currentLocation
}) => {
  const { images, mediaAssets, deliveryModes, offers, useMaxedaOfferAsWinner, addedToWishlist } = productDetails
  const t = useContext(TranslateContext)
  const medias = useMemo(() => gallerySelector(mediaAssets || images), [images, mediaAssets])
  const showLabel = isOnlineOnly(deliveryModes, useMaxedaOfferAsWinner, offers)
  const name = getProductName(productDetails)
  const { toast } = useToast()

  const slides = medias.map((item, index) => ({
    type: item.type,
    url: item.src || item.video?.source?.[0]?.src,
    alt: `${name} ${index === 0 ? '' : index + 1}`.trim(),
    bigUrl: item.src?.replace('424x424', '1400x1400') || item?.video?.source,
    smallUrl: item.thumb
  }))

  const [inWishList, setInWishList] = useState(addedToWishlist, [])
  const wishListIconTitle = getWishListIconTitle(inWishList)
  const toastTitle = getToastTitle(inWishList)

  const locale = getLocale(format, lang)
  const prefix = getPrefix(locale)

  const wishListHref = isGuest
    ? `${prefix}/login?redirectUrl=${encodeURIComponent(currentLocation)}`
    : getWishListHref(inWishList, productId)

  const onClick = (e, href) => {
    if (!isGuest) {
      e.preventDefault()
      toggleWishList({ href, toast, title: t(`wishlist.${toastTitle}`), setInWishList, inWishList })
      setInWishList(!inWishList)
      document.activeElement.blur()
      return false
    }
  }

  return (
    <div className='mxd-product-detail-layout-product mxd-product-detail-layout-image'>
      <DiscountPercentage product={productDetails} lang={lang} format={format} size='md' />
      {allowWishlist && (
        <Link
          variant='circleSmall'
          Icon={getWishListIcon(inWishList)}
          onClick={e => onClick(e, wishListHref)}
          href={wishListHref}
          title={t(`wishlist.${wishListIconTitle}`)}
          sx={{
            position: 'absolute',
            top: '12px',
            right: '12px',
            zIndex: 3,
            width: '48px',
            height: '48px',
            backgroundColor: '#FFFFFF',
            borderRadius: '8px',
            svg: {
              width: '20px',
              height: '20px'
            }
          }}
        />
      )}
      <EmblaCarousel slides={slides} options={{}} />
      {showLabel && (
        <div className='mxd-product-detail-layout-product-meta'>
          <DeliveryModeLabel deliveryMode={t('deliveryMode_exclusive')} />
        </div>
      )}
      {children}
    </div>
  )
}

export default DetailImage
